import { ImageSettingsResponseDTO } from '@/core/api/dtos/response/misc/imageSetting'
import { ImageSettings } from '@/core/api/entities/misc/imageSetting'

export class ImageSettingMapper {
	static toEntity(dto: ImageSettingsResponseDTO): ImageSettings {
		return new ImageSettings({
			sidebar_logo: dto.sidebar_logo,
			login_logo: dto.login_logo,
			login_bg: dto.login_bg,
			favicon: dto.favicon,
		})
	}

	static toEntityList(dtos: ImageSettingsResponseDTO[]): ImageSettings[] {
		return dtos.map((dto) => this.toEntity(dto))
	}
}
